import { redirect, NOT_FOUND } from 'redux-first-router';
import debug from 'debug';

import { GO_HOME } from '../store/actions/home.types';
import { GO_LOGIN, GO_LOGOUT } from '../store/actions/auth.types';
import { GO_LEARN_MORE } from '../store/actions/learnMore.types';
import { logoutAction } from '../store/actions/auth.actions';
import * as todo from '../store/actions/aktaryTechPlaceholder.types';
import { selectQuery } from '../store/reducers/location.selectors';
import {
  VIEW as USER_EMAIL_SETTINGS_VIEW,
} from '../store/actions/emailSettings';
// import { TEAMS_VIEW } from '../store/actions/teams.types';
import { VIEW as PLAYER_TRACKING_VIEW } from '../store/actions/tracking.types';

// By default, the query will update use any existing query params
// pass false to updateQuery to replace the existing query
export const goToView = (
  type,
  { params = {}, query = {}, updateQuery = true } = {},
) => async (dispatch, getState) => {
  const currentQuery = selectQuery(getState());

  dispatch({
    type,
    payload: params,
    query: {
      ...updateQuery && { ...currentQuery },
      ...query,
    },
  });
};

// export const PLAYER_VIEW = 'player/VIEW'; // TODO replace this when the time comes
const log = debug('huddle:app:routes:');

const routeConfig = {
  [NOT_FOUND]: '/404',
  [GO_HOME]: '/',
  [GO_LOGIN]: '/login',
  [GO_LEARN_MORE]: '/learn-more',
  // [GO_LOGOUT]: '/logout',
  [GO_LOGOUT]: {
    path: '/logout',
    thunk: async dispatch => {
      await dispatch(logoutAction);
    },
  },

  // ------------------------------------
  // myHuddle
  // ------------------------------------
  [USER_EMAIL_SETTINGS_VIEW]: {
    path: '/myhuddle/email',
    thunk: async (dispatch, getState) =>{
      const { loggedIn } = getState().auth;
      if (!loggedIn) dispatch(redirect({ type: GO_LOGIN }));
      else dispatch(() => ({ type: USER_EMAIL_SETTINGS_VIEW }));
    },
  },

  [PLAYER_TRACKING_VIEW]: {
    path: '/myhuddle/player-tracking',
    thunk: async (dispatch, getState) => {
      const { loggedIn } = getState().auth;
      if (!loggedIn) dispatch(redirect({ type: GO_LOGIN }));
      else {
        const { status } = getState().auth.user;
        if (status !== 'A') dispatch(redirect({ type: 'RENEW_SUBSCRIPTION_VIEW' }));
      }
    },
  },

  // ToDo
  // Draft Kit
  [todo.GO_DRAFT_KIT]: '/draft_kit',
  [todo.GO_RANKINGS]: '/draft_kit/rankings',
  [todo.GO_CHEAT_SHEETS]: '/draft_kit/cheat_sheets',
  [todo.GO_SLEEPERS]: '/draft_kit/sleepers',
  [todo.GO_PLAYER_INJURY_REPORTS]: '/draft_kit/player_injury_reports',
  [todo.GO_AVERAGE_DRAFT_POSITIONS]: '/draft_kit/average_draft_positions',
  [todo.GO_DRAFTING_STRATEGY]: '/draft_kit/drafting_strategy',
  [todo.GO_TOOLS]: '/draft_kit/tools',
  [todo.GO_INDIVIDUAL_DEFENSIVE_PLAYERS]: '/draft_kit/individual_defensive_players',
  [todo.GO_AUCTION_LEAGUES]: '/draft_kit/auction_leagues',
  // PrimaryNav Items
  // Stats
  [todo.GO_STATS]: '/stats',
  [todo.GO_WEEKLY]: '/stats/weekly',
  [todo.GO_TEAM_STATISTICS]: '/stats/team_statistics',
  // Resources
  [todo.GO_RESOURCES]: '/resources',
  [todo.GO_DEPTH_CHARTS]: '/resources/depth_charts',
  [todo.GO_NFL_SCHEDULE_GRID]: '/resources/nfl_schedule_grid',
  [todo.GO_NFL_SCHEDULE_WEEKLY_GRID]: '/resources/nfl_schedule_weekly_grid',
  [todo.GO_NFL_FULL_WEEKLY_SCHEDULE]: '/resources/nfl_full_weekly_schedule',
  [todo.GO_NFL_DRAFT]: '/resources/nfl_draft',
  [todo.GO_NFL_CALENDAR]: '/resources/nfl_calendar',
  [todo.GO_NEWSLETTER_SIGNUP]: '/resources/newsletter_signup',

  // [TEAMS_VIEW]: '/teams/:id',
};

log('routeConfig:', routeConfig);
export default routeConfig;



// WEBPACK FOOTER //
// ./src/app/routes.global.js